import Vue from 'vue'
import Router from "vue-router"
import app from './modules/app'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
    mode: 'history',
    scrollBehavior: () => ({y: 0}),
    routes: [{
        path: "/",
        component: (resolve) => require(['@/view/main.vue'], resolve),
        children: [{
            path: '/',
            component: (resolve) => require(['@/view/index/index.vue'], resolve),
        }, {
            path: '/Goods/index.html',
            component: (resolve) => require(['@/view/Goods/index.vue'], resolve),
        }, {
            path: '/Goods/off.html',
            component: (resolve) => require(['@/view/Goods/off.vue'], resolve),
        }, {
            path: '/Goods/add.html',
            component: (resolve) => require(['@/view/Goods/add.vue'], resolve),
        }, {
            path: '/Goods/edit.html',
            component: (resolve) => require(['@/view/Goods/edit.vue'], resolve),
        }, {
            path: '/Goods/terrace.html',
            component: (resolve) => require(['@/view/Goods/terrace.vue'], resolve),
        }, {
            path: '/Goods/supplierEdit.html',
            component: (resolve) => require(['@/view/Goods/supplierEdit.vue'], resolve),
        }, {
            path: '/Goods/own.html',
            component: (resolve) => require(['@/view/Goods/own.vue'], resolve),
        }, {
            path: '/Goods/reject.html',
            component: (resolve) => require(['@/view/Goods/reject.vue'], resolve),
        }, {
            path: '/Goods/reviewed.html',
            component: (resolve) => require(['@/view/Goods/reviewed.vue'], resolve),
        }, {
            path: '/Goods/unreviewed.html',
            component: (resolve) => require(['@/view/Goods/unreviewed.vue'], resolve),
        }, {
            path: '/Goods/price.html',
            component: (resolve) => require(['@/view/Goods/price.vue'], resolve),
        }, , {
            path: '/Goods/find.html',
            component: (resolve) => require(['@/view/Goods/find.vue'], resolve),
        }, {
            path: '/Member/MemberLevel.html',
            component: (resolve) => require(['@/view/Member/MemberLevel.vue'], resolve),
        }, {
            path: '/Member/MemberLevelEdit.html',
            component: (resolve) => require(['@/view/Member/MemberLevelEdit.vue'], resolve),
        }, {
            path: '/Member/MemberList.html',
            component: (resolve) => require(['@/view/Member/MemberList.vue'], resolve),
        }, {
            path: '/Member/jifen.html',
            component: (resolve) => require(['@/view/Member/jifen.vue'],resolve),
        }, {
            path: '/Member/MemberListEdit.html',
            component: (resolve) => require(['@/view/Member/MemberListEdit.vue'], resolve),
        }, {
            path: '/Member/balance.html',
            component: (resolve) => require(['@/view/Member/balance.vue'], resolve),
        }, {
            path: '/Member/balanceEdit.html',
            component: (resolve) => require(['@/view/Member/balanceEdit.vue'], resolve),
        }, {
            path: '/Member/integral.html',
            component: (resolve) => require(['@/view/Member/integral.vue'], resolve),
        }, {
            path: '/Member/integralEdit.html',
            component: (resolve) => require(['@/view/Member/integralEdit.vue'], resolve),
        }, {
            path: '/ShoppingMall/template.html',
            component: (resolve) => require(['@/view/ShoppingMall/template.vue'], resolve),
        }, {
            path: '/ShoppingMall/nav.html',
            component: (resolve) => require(['@/view/ShoppingMall/nav.vue'], resolve),
        }, {
            path: '/ShoppingMall/navEdit.html',
            component: (resolve) => require(['@/view/ShoppingMall/navEdit.vue'], resolve),
        }, {
            path: '/ShoppingMall/swiper.html',
            component: (resolve) => require(['@/view/ShoppingMall/swiper.vue'], resolve),
        }, {
            path: '/ShoppingMall/swiperEdit.html',
            component: (resolve) => require(['@/view/ShoppingMall/swiperEdit.vue'], resolve),
        }, {
            path: '/ShoppingMall/menu.html',
            component: (resolve) => require(['@/view/ShoppingMall/menu.vue'], resolve),
        }, {
            path: '/ShoppingMall/menuEdit.html',
            component: (resolve) => require(['@/view/ShoppingMall/menuEdit.vue'], resolve),
        }, {
            path: '/ShoppingMall/bgset.html',
            component: (resolve) => require(['@/view/ShoppingMall/bgset.vue'], resolve),
        }, {
            path: '/Category/index.html',
            component: (resolve) => require(['@/view/Category/index.vue'], resolve),
        }, {
            path: '/Category/edit.html',
            component: (resolve) => require(['@/view/Category/edit.vue'], resolve),
        }, {
            path: '/Repertory/index.html',
            component: (resolve) => require(['@/view/Repertory/index.vue'], resolve),
        }, {
            path: '/Repertory/in.html',
            component: (resolve) => require(['@/view/Repertory/in.vue'], resolve),
        }, {
            path: '/Repertory/out.html',
            component: (resolve) => require(['@/view/Repertory/out.vue'], resolve),
        }, {
            path: '/Repertory/outInwarehouse.html',
            component: (resolve) => require(['@/view/Repertory/outInwarehouse.vue'], resolve),
        }, {
            path: '/Repertory/batchIn.html',
            component: (resolve) => require(['@/view/Repertory/batchIn.vue'], resolve),
        }, {
            path: '/Repertory/batchOut.html',
            component: (resolve) => require(['@/view/Repertory/batchOut.vue'], resolve),
        }, {
            path: '/Repertory/goodsIn.html',
            component: (resolve) => require(['@/view/Repertory/goodsIn.vue'], resolve),
        }, {
            path: '/Repertory/goodsOut.html',
            component: (resolve) => require(['@/view/Repertory/goodsOut.vue'], resolve),
        }, {
            path: '/Repertory/detail.html',
            component: (resolve) => require(['@/view/Repertory/detail.vue'], resolve),
        }, {
            path: '/Indent/index.html',
            component: (resolve) => require(['@/view/Indent/index.vue'], resolve),
        }, {
            path: '/Indent/terrace.html',
            component: (resolve) => require(['@/view/Indent/terrace.vue'], resolve),
        }, {
            path: '/Indent/own.html',
            component: (resolve) => require(['@/view/Indent/own.vue'], resolve),
        }, {
            path: '/Indent/list.html',
            component: (resolve) => require(['@/view/Indent/list.vue'], resolve),
        }, {
            path: '/Indent/terraceList.html',
            component: (resolve) => require(['@/view/Indent/terraceList.vue'], resolve),
        }, {
            path: '/Indent/ownList.html',
            component: (resolve) => require(['@/view/Indent/ownList.vue'], resolve),
        }, {
            path: '/Indent/complete.html',
            component: (resolve) => require(['@/view/Indent/complete.vue'], resolve),
        }, {
            path: '/Indent/unfinished.html',
            component: (resolve) => require(['@/view/Indent/unfinished.vue'], resolve),
        }, {
            path: '/Indent/return.html',
            component: (resolve) => require(['@/view/Indent/return.vue'], resolve),
        }, {
            path: '/Indent/dropShipping.html',
            component: (resolve) => require(['@/view/Indent/dropShipping.vue'], resolve),
        }, {
            path: '/Indent/forGoods.html',
            component: (resolve) => require(['@/view/Indent/forGoods.vue'], resolve),
        }, {
            path: '/Indent/completed.html',
            component: (resolve) => require(['@/view/Indent/completed.vue'], resolve),
        }, {
            path: '/Indent/send.html',
            component: (resolve) => require(['@/view/Indent/send.vue'], resolve),
        }, {
            path: '/Role/index.html',
            component: (resolve) => require(['@/view/role/index.vue'], resolve),
        }, {
            path: '/Role/edit.html',
            component: (resolve) => require(['@/view/role/edit.vue'], resolve),
        }, {
            path: '/Settings/applet.html',
            component: (resolve) => require(['@/view/Settings/applet.vue'], resolve),
        }, {
            path: '/Settings/freightEdit.html',
            component: (resolve) => require(['@/view/Settings/freightEdit.vue'], resolve),
        }, {
            path: '/Settings/freight.html',
            component: (resolve) => require(['@/view/Settings/freight.vue'], resolve),
        }, {
            path: '/Pay/index.html',
            component: (resolve) => require(['@/view/Pay/index.vue'], resolve),
        }, {
            path: '/Sms/index.html',
            component: (resolve) => require(['@/view/Sms/index.vue'], resolve),
        },
            {
                path: '/Settings/expressapi.html',
                component: (resolve) => require(['@/view/Settings/expressapi.vue'], resolve),
            },
            {
                path: '/Finance/index.html',
                component: (resolve) => require(['@/view/Finance/index.vue'], resolve),
            }
            , {
                path: '/Finance/createbill.html',
                component: (resolve) => require(['@/view/Finance/createbill.vue'], resolve),
            }
            , {
                path: '/Finance/detail.html',
                component: (resolve) => require(['@/view/Finance/detail.vue'], resolve),
            }
            , {
                path: '/User/edit.html',
                component: (resolve) => require(['@/view/User/edit.vue'], resolve),
            }, {
                path: '/User/index.html',
                component: (resolve) => require(['@/view/User/index.vue'], resolve),
            }, {
                path: '/User/pass.html',
                component: (resolve) => require(['@/view/User/pass.vue'], resolve),
            }, {
                path: '/Refund/index.html',
                component: (resolve) => require(['@/view/refund/index.vue'], resolve),
            }, {
                path: '/Refund/edit.html',
                component: (resolve) => require(['@/view/refund/edit.vue'], resolve),
            },
            {
                path: '/invoice/index.html',
                component: (resolve) => require(['@/view/invoice/index.vue'], resolve),
            },
            ...app
        ]
    }, {
        path: "/login.html",
        component: (resolve) => require(['@/view/login.vue'], resolve),
    }]
})

const whiteList = ['/login.html']

router.beforeEach((to, from, next) => {
    let token = localStorage.token
    let path = to.path.toLowerCase()
    if (token && path === '/login.html') {
        next({path: '/'})
    } else if (!token && whiteList.indexOf(path) === -1) {
        next({
            path: "/login.html",
            query: {
                redirect: to.fullPath
            }
        })
    } else {
        next()
    }
})

export default router
